import styled from "styled-components"
import { responsive } from "buoy-theme"

export const ButtonRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 24px;
  margin-bottom: 24px;
  width: 100%;

  button {
    ${responsive("width", "initial", "initial", "initial", "initial", "100%")};
  }
`



// WEBPACK FOOTER //
// ./assets/payment/components/ButtonRow.js